import { makeStyles } from "@material-ui/core";

export const useStyle = makeStyles(theme => ({
  formContainer: {
    "& .MuiDialogContent-root": {
      padding: "24px"
    }
  },
}))